// Donder: inline size-pill quick-add on product grid cards
//
// Zonder duidelijke bevestiging klikken klanten meerdere keren omdat ze denken
// dat er niets gebeurt. Daarom drie signalen op verschillende plekken:
//   1. het knopje reageert direct bij de klik (niet pas na het serververzoek)
//   2. een vinkje als bevestiging, lang genoeg om te zien
//   3. de teller in de header springt zichtbaar omhoog
// en tot slot gaat de winkelwagenlade open — het enige signaal dat niet te
// missen is wanneer je halverwege een lange lijst zit te scrollen.
(function () {
  var HOLD_MS = 1100;

  /* Verzendbescherming is een dienst en staat niet in de artikellijst, dus hij
     hoort ook niet in de teller. De variant-id staat op de schakelaar in de
     lade; ontbreekt die, dan tellen we gewoon alles. */
  function visibleCount(cart) {
    var el = document.querySelector('[data-dc-shipping-protection]');
    var id = el && parseInt(el.dataset.variantId, 10);
    if (!id) return cart.item_count;
    return (cart.items || []).reduce(function (n, line) {
      return line.variant_id === id ? n : n + line.quantity;
    }, 0);
  }

  function bumpCartBubble() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = visibleCount(cart);
        document.querySelectorAll('.cart-link__bubble').forEach(function (bubble) {
          var num = bubble.querySelector('.cart-link__bubble-num');
          if (num) num.textContent = count;
          if (count > 0) bubble.classList.add('cart-link__bubble--visible');
          /* Korte schaalsprong zodat het oog de verandering oppikt */
          bubble.style.transition = 'transform .18s ease';
          bubble.style.transform = 'scale(1.45)';
          setTimeout(function () { bubble.style.transform = 'scale(1)'; }, 190);
        });
      })
      .catch(function () {});
  }

  function showPillState(pill, state, label) {
    if (state === 'busy') {
      pill.dataset.originalLabel = pill.textContent;
      pill.style.opacity = '0.55';
      pill.style.pointerEvents = 'none';
      return;
    }
    if (state === 'done') {
      pill.textContent = '✓';
      pill.style.opacity = '1';
      pill.style.background = '#101123';
      pill.style.color = '#fff';
      pill.style.borderColor = '#101123';
      return;
    }
    if (state === 'fail') {
      pill.textContent = '!';
      pill.style.opacity = '1';
      pill.style.background = '#e75189';
      pill.style.color = '#fff';
      pill.style.borderColor = '#e75189';
      return;
    }
    /* reset */
    pill.textContent = label || pill.dataset.originalLabel || pill.textContent;
    pill.style.opacity = '';
    pill.style.background = '';
    pill.style.color = '';
    pill.style.borderColor = '';
    pill.style.pointerEvents = '';
    pill.classList.remove('is-loading');
  }

  function init() {
    document.addEventListener('click', function (e) {
      var pill = e.target.closest('.grid-product__size-pill');
      if (!pill) return;

      // Stop the wrapping <a class="grid-item__link"> from navigating
      e.preventDefault();
      e.stopPropagation();

      if (pill.classList.contains('is-unavailable') || pill.classList.contains('is-loading')) return;

      var variantId = pill.dataset.variantId;
      if (!variantId) return;

      var label = pill.textContent;
      pill.classList.add('is-loading');
      showPillState(pill, 'busy');

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Failed to add: ' + r.status);
          return r.json();
        })
        .then(function (addedItem) {
          showPillState(pill, 'done');
          bumpCartBubble();

          /* Bestaande thema-events zodat andere onderdelen bijwerken */
          var event = new CustomEvent('ajaxProduct:added', {
            bubbles: true,
            detail: { product: addedItem }
          });
          document.dispatchEvent(event);
          pill.dispatchEvent(event);
          document.dispatchEvent(new CustomEvent('donder-cart:fullrefresh'));

          /* Lade openen — haal deze regel weg als het te opdringerig voelt */
          document.dispatchEvent(new CustomEvent('cart:open'));

          setTimeout(function () { showPillState(pill, 'reset', label); }, HOLD_MS);
        })
        .catch(function (err) {
          console.error('Quick add failed:', err);
          showPillState(pill, 'fail');
          setTimeout(function () { showPillState(pill, 'reset', label); }, HOLD_MS);
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
